/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/bill-items';

export const BillItemApi = {
  findToExport: async (option: FindOptions) => {
    let url = `${pathname}/find-to-export`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
  findToUpdateStock: async (billID: string, option: FindOptions) => {
    let url = `${pathname}/bill/${billID}/entity/confirm-amount-stock`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
